import { render, staticRenderFns } from "./userInfoDialog.vue?vue&type=template&id=ffe8281e&scoped=true&"
import script from "./userInfoDialog.vue?vue&type=script&lang=js&"
export * from "./userInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./userInfoDialog.vue?vue&type=style&index=0&id=ffe8281e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8281e",
  null
  
)

export default component.exports